import { FC } from 'react';

import { Modal } from '@/components/organisms/Modal';
import { useHotline } from '@/modules/auth/hooks/useHotline';

interface IProps {
  readonly onHide?: () => void;
  readonly onSaved?: () => void;
  readonly show?: boolean;
}

const LoginModal: FC<IProps> = ({ show, onHide }) => {
  // V1.4 D4: hotline now read from system_parameter; falls back to the
  // constants/common.ts default when the API is unreachable.
  const hotline = useHotline();

  function handleHide() {
    onHide?.();
  }

  return (
    <Modal
      bodyClassName="scroll-y"
      dialogClassName="mw-450px"
      onHide={handleHide}
      show={show}
      title={<h2 className="fw-bolder text-center w-100 m-0 p-0">Quên mật khẩu</h2>}
      centered
    >
      <div className="text-center">
        <p className="mb-3">Vui lòng liên hệ admin để được hỗ trợ cấp lại mật khẩu.</p>
        <p className="fw-bolder fs-4">
          Hotline:{' '}
          <a href={`tel:${hotline.replace(/[.\s]/g, '')}`}>{hotline}</a>
        </p>
      </div>
    </Modal>
  );
};

export { LoginModal };
